import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';
import CustomTheme from '../../../assets/styles/theme';

export default styled.div`
  background-color: ${({ theme }) => theme.colors.gray.shades['95']};
  /* 105 = heading height (75px) + margin size (30px) */
  min-height: calc(100vh - 75px);
  padding: 30px 30px 65px 30px;

  .container {
    position: relative;
    max-width: 840px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
    background-color: white;
    border-radius: 8px;
    padding: 60px 0;

    .form-spacer-hack {
      position: absolute;
      z-index: 300;
      left: 0;
      width: 100%;
      background-color: ${CustomTheme.form.separatorColor};

      &.first {
        bottom: 596px;
      }
      &.second {
        bottom: 132px;
      }
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    padding: 0;
    /* min-height: calc(100vh - 108px); */

    .container {
      /* min-height: calc(100vh - 108px); */
      padding: 24px 0;
      height: 100%;
      border-radius: 0px;
    }
  }
`;
